/* eslint-disable */

(function() {
  'use strict';

  //check if second drop exists, if so make drop arrow appear
  $('.top-drop .drop-arrow').each(function() {
    if (
      $(this)
        .parent()
        .siblings('.second-drop').length > 0
    ) {
      $(this).removeClass('hidden');
    }
  });

  function desktop() {
    //if desktop size, on hover of the top bar links, the children of it will slide down
    $('.top-bar > ul > li').hover(
      function() {
        $('.top-bar > ul > li > a').removeClass('open-top');
        $('.second-drop').hide();
        $('.second-drop').removeClass('open-second');
        $(this)
          .children('a')
          .addClass('open-top');
        $(this)
          .children()
          .siblings('.top-drop')
          .stop()
          .slideDown();
      },
      function() {
        //when no longer hovered it will slide up
        $('.second-drop').hide();
        $('.second-drop').removeClass('open-second');
        $('.top-bar > ul > li > a').removeClass('open-top');
        $(this)
          .children()
          .siblings('.top-drop')
          .stop()
          .slideUp();
      },
    );

    var count2 = 0;

    //the same hover action as before, except for the secondary dropdowns inside the top nav
    $('.top-bar ul li .top-drop ul li')
      .mouseenter(function() {
        count2++;
        $(this)
          .children('a')
          .siblings('.second-drop')
          .show();
        $(this)
          .children('a')
          .addClass('open-second');
        $('.open-second span').toggleClass('drop-arrow');
        $('.open-second span').toggleClass('side-arrow');

        //make marker slide up and down to hovered link position
        var marker = $(this).find('.hovered-nav');
        $(this)
          .children('a')
          .siblings('.second-drop')
          .find('li')
          .hover(function() {
            var aposition = $(this).position().top;

            $(marker).css({
              top: aposition + 5,
            });
          });
      })
      .mouseleave(function() {
        //when no longer hovered the drop hides
        count2--;
        if (!count2) {
          $('.open-second span').toggleClass('drop-arrow');
          $('.open-second span').toggleClass('side-arrow');
          $(this)
            .children('a')
            .siblings('.second-drop')
            .hide();
          $(this)
            .children('a')
            .removeClass('open-second');
        }
      });

    if ($('body').hasClass('IE8') === false) {
      var navHeight = $('ul.nav').height();
      $('.nav li a').each(function() {
        $(this).css('min-height', navHeight - 5);
      });
    }
  }

  function mobile() {
    //mob main nav
    $('.navbar-toggle').click(function() {
      $(this).toggleClass('close-icon');
      $('.navbar').toggleClass('open');
    });
  }

  //runs desktop nav function only if above 767px
  if (window.innerWidth > 991) {
    desktop();
  }

  //if less than 767:
  else {
    //top nav
    $('.top-bar > ul > li > a').click(function() {
      $('.second-drop').hide();
      $('.second-drop').removeClass('open-second');
      $(this).toggleClass('open-top');
      $(this)
        .siblings('.top-drop')
        .slideToggle();

      //check if there is a drop down for it, if there is, don't go to the page link attached (return false)
      if ($(this).siblings('.top-drop').length > 0) {
        return false;
      }
    });

    $('.top-bar ul li .top-drop ul li a').click(function() {
      if (
        $(this)
          .siblings('.second-drop')
          .hasClass('open-second')
      ) {
        $(this)
          .children('span')
          .removeClass('side-arrow');
        $(this)
          .children('span')
          .addClass('drop-arrow');

        $(this)
          .siblings('.second-drop')
          .hide();
        $(this)
          .siblings('.second-drop')
          .removeClass('open-second');
      } else {
        $('.top-bar ul li .top-drop ul li a')
          .children('span')
          .removeClass('side-arrow');
        $('.top-bar ul li .top-drop ul li a')
          .children('span')
          .addClass('drop-arrow');

        $(this)
          .children('span')
          .addClass('side-arrow');
        $(this)
          .children('span')
          .removeClass('drop-arrow');
        $('.second-drop').hide();
        $('.second-drop').removeClass('open-second');
        $(this)
          .siblings('.second-drop')
          .show();
        $(this)
          .siblings('.second-drop')
          .addClass('open-second');

        //check if there is a drop down for it, if there is, don't go to the page link attached (return false)
        if ($(this).siblings('.second-drop').length > 0) {
          return false;
        }
      }
    });
    //runs the mobile function
    mobile();
  }

  //mob topnav
  //this is the plus and minus symbol in the top left, it toggles the drop nav udner there
  $('.top-bar .show-more').click(function() {
    $(this)
      .parent()
      .toggleClass('open-more');
  });

  $(window).resize(function() {
    //on resize unbind all nav functions so they can alternate between mobile and desktop versions
    $('.nav li .navDrop').unbind();
    $('.nav li').unbind();
    $('.navbar-toggle').unbind();

    if (window.innerWidth < 991) {
      //re run the mobile nav
      mobile();
      $('.navbar').removeAttr('style');
    } else {
      $('#page-wrapper').removeAttr('style');
      $('#page-wrapper').removeClass();

      $('.navbar').removeAttr('style');
      $('.navbar').removeClass('open');
      $('.navbar-toggle').removeClass('close-icon');
      //re run the desktop nav
      desktop();
    }
  });
})();
